module.exports = __webpack_public_path__ + "img/p1.ddfc47ae.png";